import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ci67w2i6k6: FaireBrandEntity = {
  token: "b_ci67w2i6k6",
  type: "brand",
  name: "Once Again Home Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/3afa80e80f46d7bafb16b5fe4686466bba01790d1fe0b08943bee57b815c91dd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5ea6dd52510311a34f91dde7a42398cad6870edba02d7c71e53c26ccd8da478d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3afa80e80f46d7bafb16b5fe4686466bba01790d1fe0b08943bee57b815c91dd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5ea6dd52510311a34f91dde7a42398cad6870edba02d7c71e53c26ccd8da478d.jpeg",
  location: "La Grange, IL, USA",
  minimumOrderDollars: 104,
  rating: 4.9,
  reviewCount: 57,
  isTopShop: true,
  isInsider: true,
  description:
    "The original and authentic recycled towel. \n\nAt Once Again Home Co., we believe thoughtful design, reliable performance, and sustainability should go hand in hand. Woman-owned and family-led, we create recycled home textiles inspired by modern color, pattern, and everyday living. Our towels and home essentials are thoughtfully developed with function at the forefront, focusing on absorbency, durability, and fast-drying performance. Using sustainable materials and responsible production practices, we design pieces that look beautiful, work hard, and bring ease and joy to real homes. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:29.885Z",
    importedBy: "entity-db-cli",
  },
};
